// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const DiscountCircle = ({
  classes,
  value,
  discountType,
}) => {
  return (
    <div className={classes.circleContainer}>
      {discountType === 1
        ? (<p className={classes.circleText}>{`+${value}%`}</p>)
        : (<p className={classes.circleText}>{`+ £${value}`}</p>)}
    </div>
  );
};

DiscountCircle.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.number,
  discountType: PropTypes.number,
};

DiscountCircle.defaultProps = {
  classes: {},
  value: 0,
  discountType: 1,
};

export default withStyles(styles)(DiscountCircle);
